<template>
  <b-modal
    :id="id"
    hide-footer
    centered
    hide-header
    header-class="!text-center"
  >
    <div class="font-semibold text-xl mt-[9px] text-black leading-relaxed tracking-wide text-center align-middle mb-[5px]">
      Preview Template {{ defineBroadcastType(typeMessage) }}
    </div>
    <div class="mt-[9px] mb-[9px]">
      <div class="flex mb-1 justify-between items-center">
        <div>
          <span class="text-black">Pesan *</span>
        </div>
        <div
          v-if="spintaxContent.length > 1 "
          class="flex bg-[#F4F4F4] rounded h-fit w-fit items-center p-[4px] gap-1"
        >
          <button
            :disabled="indexVariant === 0"
            class="px-[4px] py-[2px] rounded "
            :class="indexVariant === 0 ? 'bg-[#F4F4F4]': 'bg-white' "
            @click="handleMoveVariant('min')"
          >
            <b-icon
              icon="chevron-left"
            />
          </button>
          <span class="mx-1 text-sm">{{ variantNames }}</span>
          <button
            :disabled="indexVariant === spintaxContent.length -1"
            :class="indexVariant === spintaxContent.length - 1 ? 'bg-[#F4F4F4]': 'bg-white' "
            class="px-[4px] rounded py-[2px] "
            @click="handleMoveVariant('plus')"
          >
            <b-icon
              icon="chevron-right"
            />
          </button>
        </div>
      </div>
      <b-form-textarea
        v-show="content"
        id="textarea-no-resize"
        v-model="content"
        class="min-h-[150px]"
        disabled
        resize
      />
      <div
        v-show="image"
        class="flex mt-2 items-start gap-2"
      >
        <div>
          <b-img
            :src="image"
            alt="icon-send"
            class="rounded-md object-cover w-[100px] h-[100px]"
          />
        </div>
        <div
          class="w-full"
        >
          <b-form-group
            label="Caption gambar (opsional)"
            label-for="caption"
          >
            <b-form-textarea
              id="caption"
              v-model="caption"
              disabled
              maxlength="1000"
              rows="1"
            />
          </b-form-group>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    template: {
      type: [String, Array],
      required: true,
    },
    image: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
    id: {
      default: 'modal-preview-template',
      type: String,
    },
    typeMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      indexVariant: 0,
      content: '',
      variantNames: '',
    }
  },
  computed: {
    spintaxContent() {
      if (Array.isArray(this.template)) {
        return this.template
      }
      return []
    },
  },
  watch: {
    template: {
      immediate: true,
      handler() {
        if (Array.isArray(this.template)) {
          if (this.template.length > 0) {
            this.indexVariant = 0
            this.content = this.template[this.indexVariant]
            this.variantNames = this.indexVariant === 0 ? 'Pesan Utama' : `Variant ${this.indexVariant}`
          } else {
            this.indexVariant = 0
            this.content = ''
            this.variantNames = ''
          }
        } else {
          this.content = this.template || ''
        }
      },
    },
  },
  methods: {
    handleMoveVariant(type) {
      if (type === 'min') {
        this.indexVariant -= 1
        this.content = this.spintaxContent[this.indexVariant]
        this.variantNames = this.indexVariant === 0 ? 'Pesan Utama' : `Variant ${this.indexVariant}`
      } else {
        this.indexVariant += 1
        this.content = this.spintaxContent[this.indexVariant]
        this.variantNames = this.indexVariant === 0 ? 'Pesan Utama' : `Variant ${this.indexVariant}`
      }
    },
    defineBroadcastType(type) {
      const broadcast = {
        TEXT: 'Pesan Teks',
        MEDIA: 'Pesan Media',
        TEXT_MEDIA: 'Pesan Teks & Media',
      }
      return broadcast[type]
    },
  },
}
</script>
